















































































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import _ from 'lodash';
import {randomString} from '@/script/util';
import {eGameStage} from "@/common/enumData";
import Toast from "@/script/message";

@Component({
    components: {},
})
export default class AddGameInfo extends Vue {
    @Prop({default: false}) set!: boolean;
    @Prop() projectInfo !: any;
    @Prop() isEditProject !: any;
    @Prop() isUpdateProject !: any;
    toast = new Toast();
    gameStage = eGameStage;

    title: string = '';
    description: string = '';
    hashtagsArr: string[] = [];
    currentInput = ''
    // chips: string[] = [];
    prevImg: any = '';
    prevGif: any = '';
    thumbFile: any = null;
    gamePath: string = ""
    autoGamePath: boolean = true;

    confirmedGamePath: boolean | null = null;

    isTitleErr: boolean = false;
    isDescErr: boolean = false;
    isHashtagErr: boolean = false;
    isThumbErr: boolean = false;

    thumbFile2: any = null;

    gamePathError: string = "";
    waitGamePath: boolean = false;

    beforeRouteLeave(to, from, next) {
        if (to.name == "AddGameFile") {
            next();
        }
        else if (
            this.title ||
            this.description ||
            this.hashtagsArr.length > 0
            // ||  this.thumbFileUrl ||
            // this.thumbFile2Url
        ) {
            if (
                confirm(
                    "작성하신 글은 저장되지않고 지워집니다. 이 페이지를 나가시겠습니까?"
                )
            ) {
                this.resetLocalStorage();
                next();

            }
            else {
            }
        }
        else {
            this.resetLocalStorage();
            next();
        }
    }

    mounted() {


        // this.callLocalStorageData();
    }

    callLocalStorageData() {
        this.title = localStorage.getItem('title')!
        this.description = localStorage.getItem('description')!
        this.hashtagsArr = localStorage.getItem('hashtagsArr')!.split(',')
    }

    @Watch('projectInfo')
    callUpdateProjectData() {
        const {name, description, picture, picture2, hashtags, game, stage, picture_webp} = this.projectInfo;
        const {pathname} = game;

        this.title = name;
        this.description = description;
        this.prevImg = (picture_webp || picture) + '?_=' + Date.now();
        this.prevGif = picture2;
        this.gamePath = pathname;
        this.hashtagsArr = hashtags ? hashtags.split(',') : []
        this.$store.commit("gameStage", stage);
    }


    init() {
        this.isTitleErr = false;
        this.isDescErr = false;
        this.isHashtagErr = false;
        this.isThumbErr = false;
    }

    resetLocalStorage() {
        localStorage.removeItem('title')
        localStorage.removeItem('description')
        localStorage.removeItem('hashtagsArr')
        localStorage.removeItem('thumbnail')
    }

    async checkGamePath() {
        this.waitGamePath = true;
        if (this.gamePath) {
            const result = await this.$api.confirmGamePath(this.gamePath);
            if (result && result.success) {
                this.confirmedGamePath = true;
                this.gamePathError = "";
            }
            else {
                this.gamePathError = `${this.$t('usedId')}`;// '사용중인 아이디 입니다. 다른 아이디를 입력하세요.';
            }
        }
        this.waitGamePath = false;
    }

    prevPage() {
        this.resetLocalStorage();
        // this.$store.commit("gameStage", null);
        this.$emit('stage', null)
        this.$emit('isActivePublish', false)
    }

    validityCheck() {
        let isError: boolean = false;

        if (!this.title) {
            this.isTitleErr = true;
            isError = true;
        }

        if (!this.description) {
            this.isDescErr = true;
            isError = true;
        }

        if (this.hashtagsArr.length === 0) {
            this.isHashtagErr = true;
            isError = true;
        }
        if (!this.thumbFile && !this.prevImg) {
            this.isThumbErr = true;
            isError = true;
        }
        return isError ? false : true;

    }

    async save() {
        this.init();

        if (!this.validityCheck()) {
            this.$emit('gameInfoDone', false)
            return;
        }


        console.log('gameStage', this.$store.getters.gameStage)
        console.log('projectInfo', this.projectInfo)

        await this.commitGameInfo();
        if (this.isEditProject) {
            // 개발 단계를 변경하면 업로드한 게임 파일이 삭제됩니다. 개발 단계를 변경하시겠습니까?
            if (this.$store.getters.gameStage === this.gameStage.Dev) {
                if (this.projectInfo.projectVersions.length === 0) {
                    this.$emit('gameInfoDone', true)
                }else{
                    this.updateProject();
                    return;
                }
            }
            else {
                if (this.projectInfo.projectVersions.length === 0) {
                    this.$emit('gameInfoDone', true)
                }else{
                    this.updateProject();
                    return;
                }
                this.$emit('gameInfoDone', true)
            }



        }
        else {
            // if (this.$store.getters.gameStage === this.gameStage.Dev) {
            //     this.uploadGame()
            // }
            this.$emit('gameInfoDone', true)
        }


    }

    @Watch('isUpdateProject')
    updateProject() {
        // if (!this.isUpdateProject ) {
        //     return;
        // }
        if (!this.validityCheck()) {
            this.$emit('gameInfoDone', false)
            return;
        }

        const option: any = {
            id: this.projectInfo.id,
            name: localStorage.getItem('title'),
            description: localStorage.getItem('description'),
            hashtags: localStorage.getItem('hashtagsArr'),
            stage: this.$store.getters.gameStage
        };

        console.log('this.thumbFile2', this.thumbFile2)

        this.$api.updateProject(option, this.thumbFile, this.thumbFile2)
            .then((res) => {

                this.$store.dispatch('project', this.projectInfo.id)
                this.toast.clear();
                this.toast.successToast(`${this.$t('update.done')}`);
                this.$router.push(`/${this.$i18n.locale}/projectList`)
            })
            .catch((err) => {
            })
    }


    async createGamePath() {
        let count = 0;
        while (!this.confirmedGamePath && count < 10) {
            count++;
            this.gamePath = randomString(11);
            const result = await this.$api.confirmGamePath(
                this.gamePath
            );
            if (result && result.success) {
                this.confirmedGamePath = true;
            }
        }
    }

    async commitGameInfo() {

        if (!this.isEditProject) {
            if (!this.confirmedGamePath) {
                if (!this.autoGamePath) {
                    alert(`${this.$t('check.gameId')}`)

                }
                else {
                    await this.createGamePath();
                    if (!this.confirmedGamePath) {
                        return;
                    }
                }
            }
        }

        const gameInfo = {
            name: this.title,
            description: this.description,
            pathname: this.gamePath,
            project_picture: this.thumbFile,
            project_picture2: this.thumbFile2,
            hashtags: this.hashtagsArr.toString(),
            stage: this.$store.getters.gameStage,
        };

        // this.$store.commit("uploadGameFiles", []);
        this.$store.commit("gameFileInfoObj", {});
        this.$store.commit("gameInfoObj", gameInfo);
    }

    uploadFile() {
        (this.$refs.thumbnail as HTMLElement).click();
    }

    uploadGif() {
        (this.$refs.thumbnailGif as HTMLElement).click();
    }

    onFileChange(event: { target: { files: any } }) {

        if (event.target.files[0].size < 1024 * 1024 * 4) {

            // this.fileName = event.target.files[0].name
            this.thumbFile = event.target.files[0];
            this.checkActivePublish();
            const reader = new FileReader();
            reader.onload = e => {
                this.prevImg = e.target!.result;
                this.$store.commit('thumbFile', this.thumbFile)

                localStorage.setItem('thumbnail', this.prevImg);
                this.isThumbErr = false;
            };
            reader.readAsDataURL(event.target.files[0]);

        }
        else {
            alert(`${this.$t('maxFile.size.4mb')}`)

        }
    }

    deleteThumbnail() {
        this.prevImg = '';
        localStorage.removeItem('thumbnail')
    }

    deleteThumbnail2() {
        this.prevGif = '';
        this.thumbFile2 = 'rm_file2';
    }

    onGifChange(event: { target: { files: any } }) {
        if (event.target.files[0].size < 1024 * 1024 * 4) {
            this.thumbFile2 = event.target.files[0];
            // this.fileName = event.target.files[0].name
            // this.updateFile = event.target.files[0]
            const reader = new FileReader();
            reader.onload = e => {
                this.prevGif = e.target!.result
            };
            reader.readAsDataURL(event.target.files[0]);
        }
        else {
            alert(`${this.$t('maxFile.size.4mb')}`)
        }
    }


    checkActivePublish() {
        if (this.$store.getters.gameStage === this.gameStage.Dev) {
            if (this.title && this.description && this.hashtagsArr.length !== 0 && (this.thumbFile || (this.projectInfo && this.projectInfo.picture))) {
                this.commitGameInfo();
                this.$emit('isActivePublish', true)
            }
            else {
                this.$emit('isActivePublish', false)
            }

        }

    }

    @Watch('$store.getters.gameStage')
    watchGameStage() {
        this.checkActivePublish()
    }


    deleteProject() {
        this.$api.deleteProject(this.projectInfo.id)
            .then((res) => {
                this.$store.getters.projects[this.projectInfo.id] = null;
                this.toast.clear();
                this.toast.successToast(`${this.$t('deleted.game.success.msg')}`)
            })
            .catch(() => {
                this.toast.clear();
                this.toast.failToast(`${this.$t('deleted.game.fail.msg')}`)

            })
            .finally(() => {
                this.$modal.hide('deleteProject')
                this.$router.replace(`/${this.$i18n.locale}/projectList`);
            })
    }

    uploadGame() {
        const {gameInfoObj, gameFileInfoObj, uploadGameFiles} = this.$store.getters;

        this.$api.createProject(
            gameInfoObj,
            gameFileInfoObj,
            uploadGameFiles
        )
            .then((res) => {

                this.toast.successToast(`${this.$t('devLog.upload.done')}`);
                this.$router.push(`/${this.i18n.locale}/projectList`)
            })
            .catch((err) => {

            })
    }

    ableFileUpload() {
        // if (this.$store.getters.gameStage === eGameStage.Dev) {
        //     console.log('dev 상태')
        //     return false;
        // }
        // else
        if (this.projectInfo && this.projectInfo.projectVersions.length !== 0) {
            return false;
        }
        else {
            return true;
        }
    }


    /**
     * tag chips
     */
    saveChip() {
        const {hashtagsArr, currentInput, set} = this;
        if (!_.includes(hashtagsArr, currentInput.trim())) {
            ((set && hashtagsArr.indexOf(currentInput) === -1) || !set) && hashtagsArr.push(currentInput.trim());
        }
        this.currentInput = '';
    }

    deleteChip(index) {
        this.hashtagsArr.splice(index, 1);
    }

    backspaceDelete({which}) {
        which == 8 && this.currentInput === '' && this.hashtagsArr.splice(this.hashtagsArr.length - 1);
    }

    /**
     * 게임 정보 local storage 저장
     */
    autoSave() {

        if (this.title) {
            localStorage.setItem('title', this.title)
            this.isTitleErr = false;
        }
        else {
            localStorage.removeItem('title')
        }

        if (this.description) {
            localStorage.setItem('description', this.description)
            this.isDescErr = false;
        }
        else {
            localStorage.removeItem('description')
        }

        if (this.currentInput) {
            this.saveChip();
        }
        if (this.hashtagsArr.length > 0) {
            this.isHashtagErr = false;
            localStorage.setItem('hashtagsArr', this.hashtagsArr.toString())
        }
        else {
            localStorage.removeItem('hashtagsArr')
        }
        this.checkActivePublish();
    }


}
